enum StageType {
  DESERT1 = "D1",
  DESERT2 = "D2",
  DESERT3 = "D3",
  DESERT4 = "D4",
  DESERT5 = "D5",
  DESERT6 = "D6",
  DESERT7 = "D7",
  DESERT8 = "D8",
  DESERT9 = "D9",
  DESERT10 = "D10",
  DESERT11 = "D11",
  GREEN1 = "G1",
  GREEN2 = "G2",
  GREEN3 = "G3",
  GREEN4 = "G4",
  GREEN5 = "G5",
  GREEN6 = "G6",
  GREEN7 = "G7",
  GREEN8 = "G8",
  GREEN9 = "G9",
  GREEN10 = "G10",
  JUNGLE1 = "J1",
  JUNGLE2 = "J2",
  JUNGLE3 = "J3",
  CITY1 = "C1",
  CITY2 = "C2",
  CITY3 = "C3",
  CYBERPUNK1 = "CP1",
  CYBERPUNK2 = "CP2",
  CYBERPUNK3 = "CP3",
  METAVERSE1 = "M1",
  METAVERSE2 = "M2",
  METAVERSE3 = "M3",
}

export default StageType;
